import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import CustomSelect from './CustomSelect';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, FormControl, Select, MenuItem } from '@mui/material';
import RequireVip from './RequireVip'
import { Helmet } from 'react-helmet-async';
import { auth } from './Firebase'; // Dodano import auth z Firebase
import { useCompetitions } from './CompetitionContext';

const getTopGradientColor = (value) => {
  if (value === 0) return 'rgba(255, 255, 255, 0.3)'; // Pojaśniony neutralny szary
  const scaledValue = Math.max(0, value / 0.8);
  const grayBase = 255;
  const r = Math.round(grayBase * (1 - scaledValue));
  const g = Math.round(grayBase * (1 - scaledValue) + 255 * scaledValue);
  const b = Math.round(grayBase * (1 - scaledValue) + 50 * scaledValue); // Lekkie niebieskie dla głębi
  const alpha = 0.3 + scaledValue * 0.7;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const getRelegationGradientColor = (value) => {
  if (value === 0) return 'rgba(255, 255, 255, 0.3)';
  const scaledValue = value;
  const grayBase = 255;
  const r = Math.round(grayBase * (1 - scaledValue) + 255 * scaledValue);
  const g = Math.round(grayBase * (1 - scaledValue));
  const b = Math.round(grayBase * (1 - scaledValue));
  const alpha = 0.3 + scaledValue * 0.7;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const convertUTCToLocal = (utcValue) => {
  let utcDate;
  if (typeof utcValue === 'number') {
    utcDate = new Date(utcValue);
  } else if (typeof utcValue === 'string') {
    utcDate = new Date(utcValue + 'Z');
  } else {
    console.error('Nieprawidłowy typ created_at:', typeof utcValue, utcValue);
    return 'Błąd daty';
  }
  return utcDate.toLocaleString('pl-PL', { timeZone: 'Europe/Warsaw' });
};

const PointsThreshold = () => {
  const { competitionId } = useParams();
  const { competitions, loading } = useCompetitions();
  const [data, setData] = useState({
    thresholdProbabilities: [],
    competitionConfig: {},
  });
  const [selectedSimulationId, setSelectedSimulationId] = useState(null);
  const [simulationList, setSimulationList] = useState([]);
  const [currentSimulationIndex, setCurrentSimulationIndex] = useState(0);
  const [error, setError] = useState(null);
  const [leagueName, setLeagueName] = useState('');
  const [selectedComp, setSelectedComp] = useState(null); // ← Dodany stan dla selectedComp

  const simulationOptions = simulationList.map((sim, index) => ({
    value: index,
    label: sim.displayName,
  }));

  const fetchSimulationData = useCallback(async (simulationId) => {
    try {
      console.log('Pobieranie danych dla simulationId:', simulationId);
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/simulation/${simulationId}`);
      console.log('Odpowiedź z API:', response.data);
      setData(prev => ({
        ...prev,
        thresholdProbabilities: response.data.thresholdProbabilities || [],
      }));
    } catch (err) {
      console.error('Błąd podczas pobierania danych:', err);
      setError('Błąd podczas pobierania danych progów punktowych: ' + (err.message || 'Nieznany błąd'));
    }
  }, []);

  useEffect(() => {
	  if (loading || !competitionId) return;

	  const selectedComp = Object.values(competitions)
		.flat()
		.find(comp => comp.competition_id === parseInt(competitionId));

	  if (!selectedComp) {
		setError('Liga nie znaleziona.');
		return;
	  }
	  setSelectedComp(selectedComp); // ← Zapisujemy do stanu


	  console.log('Selected competition:', selectedComp);
	  const displayName =
		selectedComp.group && selectedComp.group !== 'NULL' && selectedComp.group.trim() !== ''
		  ? `${selectedComp.name} (${selectedComp.group.charAt(0).toUpperCase() + selectedComp.group.slice(1)})`
		  : selectedComp.name;
	  setLeagueName(displayName);

	  setData(prev => ({
		...prev,
		competitionConfig: selectedComp.competitionConfig || {
		  promotion_spots: selectedComp.promotion_spots || 0,
		  promotion_spots_name: selectedComp.promotion_spots_name || 'Awans',
		  promotion_playoff_spots: selectedComp.promotion_playoff_spots || 0,
		  promotion_playoff_spots_name: selectedComp.promotion_playoff_spots_name || 'Baraże o awans',
		  relegation_spots: selectedComp.relegation_spots || 0,
		  relegation_spots_name: selectedComp.relegation_spots_name || 'Spadek',
		  relegation_playoff_spots: selectedComp.relegation_playoff_spots || 0,
		  relegation_playoff_spots_name: selectedComp.relegation_playoff_spots_name || 'Baraże o utrzymanie',
		  is_balancing_active: selectedComp.is_balancing_active
		},
	  }));

	  // Pobieranie listy symulacji z nowego endpointu
	  console.log('Pobieram symulacje dla competitionId:', competitionId);
	  axios.get(`${process.env.REACT_APP_API_URL}/api/competition/${competitionId}/simulations`)
		.then(response => {
		  console.log('Pobrano symulacje:', response.data);
		  const simList = response.data.map(sim => ({
			...sim,
			userId: sim.user_id, // Jawne mapowanie user_id na userId
			displayName: sim.conditions !== "" ? `${convertUTCToLocal(sim.created_at)} (*)` : convertUTCToLocal(sim.created_at)
		  }));
		  const filteredSimList = simList.filter(sim => {
      const isDefault = !sim.userId || sim.userId === ""; // null lub pusty string = default
      const isOwned = auth.currentUser?.uid && sim.userId === auth.currentUser.uid; // Tylko dla zalogowanego
      console.log(`Sim: ${sim.simulation_id}, userId: ${sim.userId}, isDefault: ${isDefault}, isOwned: ${isOwned}`); // Debug
      return isDefault || isOwned;
    });
      setSimulationList(filteredSimList);
    const initialIndex = 0;
    setCurrentSimulationIndex(initialIndex);
    const initialSimId = filteredSimList.length > 0 ? filteredSimList[initialIndex].simulation_id : null;
    setSelectedSimulationId(initialSimId);
    console.log('Filtered simList:', filteredSimList); // Debug po filtrze
		})
		.catch(err => {
		  setError('Błąd podczas pobierania listy symulacji.');
		  console.error('Błąd pobierania symulacji:', err.response?.data || err.message);
		});
	}, [competitionId, competitions, loading]);

  useEffect(() => {
    if (selectedSimulationId) {
      fetchSimulationData(selectedSimulationId);
    }
  }, [selectedSimulationId, fetchSimulationData]);

  const handleSimulationSelect = (event) => {
    const selectedIndex = event.target.value;
    setCurrentSimulationIndex(selectedIndex);
    setSelectedSimulationId(simulationList[selectedIndex].simulation_id);
  };
  
  
  const pageTitle = `${leagueName} - Progi punktowe | SymuLiga`;
  const pageDesc = `Analiza matematyczna progów punktowych dla ${leagueName}. Sprawdź, ile punktów do awansu, spadku i utrzymania w Twojej lidze. Próg awansu, próg spadku`;

  if (loading) {
    return (
      <Box sx={{ textAlign: 'center', padding: '20px' }}>
        <Typography variant="h6">Ładowanie...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: 'center', padding: '20px' }}>
        <Typography variant="h6">{error}</Typography>
      </Box>
    );
  }

  if (!data.thresholdProbabilities.length) {
    return (
      <Box sx={{ textAlign: 'center', padding: '20px' }}>
        <Typography variant="h6">Ładowanie...</Typography>
      </Box>
    );
  }

  const pointsData = {};
  data.thresholdProbabilities.forEach(item => {
    if (!pointsData[item.points]) {
      pointsData[item.points] = { top_promotion: 0, top_playoff: 0, avoid_relegation: 0 };
    }
    pointsData[item.points][item.thresholdType] = item.probability;
  });

  const uniquePoints = Object.keys(pointsData).map(Number).sort((a, b) => b - a); // Sortowanie malejące

  // Filtruj punkty, usuwając identyczne wiersze od góry
  const filteredPoints = [...uniquePoints]; // Kopia wszystkich punktów na start
  let i = 0;

  while (i < filteredPoints.length - 1) {
    const currentPoints = filteredPoints[i];
    const nextPoints = filteredPoints[i + 1];
    const currentData = pointsData[currentPoints];
    const nextData = pointsData[nextPoints];

    if (currentData && nextData && 
        currentData.top_promotion === nextData.top_promotion &&
        currentData.top_playoff === nextData.top_playoff &&
        currentData.avoid_relegation === nextData.avoid_relegation) {
      filteredPoints.splice(i, 1); // Usuń bieżący (pierwszy identyczny)
    } else {
      i++; // Przejdź do następnego, jeśli się różni
      if (i < filteredPoints.length - 1 && !nextData) break; // Zatrzymaj, jeśli brak danych
      if (currentData && nextData) break; // Zatrzymaj po pierwszej różnicy
    }
  }

  // Usuwanie duplikatów od dołu z odwrotną kolejnością
  let j = filteredPoints.length - 1;
  while (j > 0) {
    if (j >= filteredPoints.length) {
      j--; // Dostosuj, jeśli tablica została skrócona
      continue;
    }
    const currentPoints = filteredPoints[j];
    const prevPoints = filteredPoints[j - 1];
    const currentData = pointsData[currentPoints];
    const prevData = pointsData[prevPoints];

    if (currentData && prevData && 
        currentData.top_promotion === prevData.top_promotion &&
        currentData.top_playoff === prevData.top_playoff &&
        currentData.avoid_relegation === prevData.avoid_relegation) {
      filteredPoints.splice(j, 1); // Usuń bieżący (ostatni identyczny)
    } else {
      j--; // Przejdź do poprzedniego, jeśli się różni
      if (j > 0 && (!currentData || !prevData)) break; // Zatrzymaj, jeśli brak danych
      if (currentData && prevData) break; // Zatrzymaj po pierwszej różnicy
    }
  }
  console.log('isBalancing:', data.competitionConfig.is_balancing_active);

  return (
  <>
	<Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
    </Helmet>
    <Box sx={{ padding: { xs: '2px', sm: '5px', md: '10px' } }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'column' },
          justifyContent: { xs: 'center', sm: 'space-between' },
          alignItems: 'center',
          mb: 2,
          gap: 1,
        }}
      >
        <Typography variant="h5" component="h1" sx={{ textAlign: { xs: 'center', sm: 'center' }, fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>
          Progi punktowe - {leagueName}
        </Typography>
        {simulationList.length > 0 && (
          <CustomSelect
		  value={currentSimulationIndex}
		  onChange={handleSimulationSelect}
		  options={simulationOptions}
		  displayEmpty // Przekazanie propów specyficznych dla Select
		  inputProps={{ 'aria-label': 'Wybierz symulację' }} // Przekazanie inputProps
    />
        )}
      </Box>
      <TableContainer component={Paper} sx={{ overflowX: 'auto', borderRadius: '12px', width: 'fit-content', margin: '0 auto' }}>
        <Table sx={{ minWidth: 280, tableLayout: 'auto', borderCollapse: 'collapse' }}>
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ position: 'sticky', left: 0, top: 0, zIndex: 3, backgroundColor: 'background.paper', minWidth: 40, padding: '8px', fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                Punkty
              </TableCell>
              {data.competitionConfig.promotion_spots > 0 && (
                <TableCell align="center" sx={{ backgroundColor: 'background.paper', minWidth: 60, padding: '6px', fontSize: { xs: '0.7rem', sm: '0.8rem' }, borderBottom: '2px solid rgba(224, 224, 224, 1)' }}>
                  {data.competitionConfig.promotion_spots_name}
                </TableCell>
              )}
              {data.competitionConfig.promotion_playoff_spots > 0 && (
                <TableCell align="center" sx={{ backgroundColor: 'background.paper', minWidth: 60, padding: '6px', fontSize: { xs: '0.7rem', sm: '0.8rem' }, borderBottom: '2px solid rgba(224, 224, 224, 1)' }}>
                  {data.competitionConfig.promotion_playoff_spots_name}
                </TableCell>
              )}
			  {data.competitionConfig.relegation_playoff_spots > 0 && (!data.competitionConfig.is_balancing_active) && (
                <TableCell align="center" sx={{ backgroundColor: 'background.paper', minWidth: 60, padding: '6px', fontSize: { xs: '0.7rem', sm: '0.8rem' }, borderBottom: '2px solid rgba(224, 224, 224, 1)' }}>
                  {data.competitionConfig.relegation_playoff_spots_name}
                </TableCell>
              )}
              {data.competitionConfig.relegation_spots > 0 &&  (!data.competitionConfig.is_balancing_active) && (
                <TableCell align="center" sx={{ backgroundColor: 'background.paper', minWidth: 60, padding: '6px', fontSize: { xs: '0.7rem', sm: '0.8rem' }, borderBottom: '2px solid rgba(224, 224, 224, 1)' }}>
                  {data.competitionConfig.relegation_spots_name}
                </TableCell>
              )}              
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredPoints.map(points => (
              <TableRow key={points}>
			    <RequireVip variant='short-text' requirement={selectedComp.stats_requirement}
					sx={{ position: 'right', zIndex: 1, backgroundColor: 'background.paper', minWidth: 40, padding: '6px', fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>

					<TableCell align="center" sx={{ position: 'sticky', left: 0, zIndex: 1, backgroundColor: 'background.paper', minWidth: 40, padding: '6px', fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
					  {points}
					</TableCell>
				</RequireVip>
                {data.competitionConfig.promotion_spots > 0 && (
                  <TableCell align="center" sx={{ backgroundColor: getTopGradientColor(pointsData[points].top_promotion), color: 'black', fontWeight: 'bold', padding: '6px', fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                    {(Math.min(pointsData[points].top_promotion, 1) * 100).toFixed(1)}%
                  </TableCell>
                )}
                {data.competitionConfig.promotion_playoff_spots > 0 && (
                  <TableCell align="center" sx={{ backgroundColor: getTopGradientColor(pointsData[points].top_playoff), color: 'black', fontWeight: 'bold', padding: '6px', fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                    {(Math.min(pointsData[points].top_playoff, 1) * 100).toFixed(1)}%
                  </TableCell>
                )}
				{data.competitionConfig.relegation_playoff_spots > 0 && (!data.competitionConfig.is_balancing_active) && (
                  <TableCell align="center" sx={{ backgroundColor: getRelegationGradientColor(Math.max(0, 1 - pointsData[points].avoid_playoff)), color: (1 - pointsData[points].avoid_playoff) > 0.5 ? 'white' : 'black', fontWeight: 'bold', padding: '6px', fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                    {(Math.max(0, 1 - pointsData[points].avoid_playoff) * 100).toFixed(1)}%
                  </TableCell>
                )}
                {data.competitionConfig.relegation_spots > 0 && (!(data.competitionConfig.is_balancing_active)) &&(
                  <TableCell align="center" sx={{ backgroundColor: getRelegationGradientColor(Math.max(0, 1 - pointsData[points].avoid_relegation)), color: (1 - pointsData[points].avoid_relegation) > 0.5 ? 'white' : 'black', fontWeight: 'bold', padding: '6px', fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                    {(Math.max(0, 1 - pointsData[points].avoid_relegation) * 100).toFixed(1)}%
                  </TableCell>
                )}
                
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
	</>
  );
};

export default PointsThreshold;